module.exports = __webpack_public_path__ + "img/Scale.6f571379.png";